import React from 'react';
import { Wrapper, SpinnerIcon } from './styled';

const Spinner = ({ size }) => (
  <Wrapper>
    <SpinnerIcon size={ size } />
  </Wrapper>
);

export default Spinner;
